module.exports = __webpack_public_path__ + "static/media/3d-plan_general_3Shape.ebcd32cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general_3Shape.svg
// module id = 934
// module chunks = 0